export class ShortCodesFakeDb {
    public static shortCodes = [
        {
            title: 'Commercial Properties',
            templates: ['commercial_property'],
            codes: {
                current_price: '[commercial_property attribute=current_price]',
                reference: '[commercial_property attribute=reference]',
                other_reference: '[commercial_property attribute=other_reference]',
                external_reference: '[commercial_property attribute=external_reference]',
                address_street: '[commercial_property attribute=address_street]',
                address_street_nr: '[commercial_property attribute=address_street_nr]',
                address_portal: '[commercial_property attribute=address_portal]',
                address_floor: '[commercial_property attribute=address_floor]',
                address_door_nr: '[commercial_property attribute=address_door_nr]',
                postal_code: '[commercial_property attribute=postal_code]',
                po_box: '[commercial_property attribute=po_box]',
                city: '[commercial_property attribute=city]',
                province: '[commercial_property attribute=province]',
                region: '[commercial_property attribute=region]',
                country: '[commercial_property attribute=country]',
                google_address: '[commercial_property attribute=google_address]',
                address_road_type: '[commercial_property attribute=address_road_type]',
                latitude: '[commercial_property attribute=latitude]',
                longitude: '[commercial_property attribute=longitude]',
                cadastral_number: '[commercial_property attribute=cadastral_number]',
                cadastral_number_for: '[commercial_property attribute=cadastral_number_for]',
                property_register: '[commercial_property attribute=property_register]',
                idu_cru: '[commercial_property attribute=idu_cru]',
                finca_number: '[commercial_property attribute=finca_number]',
                year_built: '[commercial_property attribute=year_built]',
                transaction_type: '[commercial_property attribute=transaction_type]',
                property_state: '[commercial_property attribute=property_state]',
                occupation_license: '[commercial_property attribute=occupation_license]',
                type_one: '[commercial_property attribute=type_one]',
                type_two: '[commercial_property attribute=type_two]',
                currency: '[commercial_property attribute=currency]'
            }
        },
        {
            title: 'Clients',
            templates: ['client'],
            codes: {
                client_status: '[client attribute=client_status]',
                client_type: '[client attribute=client_type]',
                client_type_other: '[client attribute=client_type_other]',
                person_type: '[client attribute=person_type]',
                name: '[client attribute=name]',
                gender: '[client attribute=gender]',
                date_of_birth: '[client attribute=date_of_birth]',
                place_of_birth: '[client attribute=place_of_birth]',
                primary_nationality: '[client attribute=primary_nationality]',
                secondary_nationality: '[client attribute=secondary_nationality]',
                citizenship: '[client attribute=citizenship]',
                relationship_status: '[client attribute=relationship_status]',
                email: '[client attribute=email]',
                mobile_country: '[client attribute=mobile_country]',
                mobile_number: '[client attribute=mobile_number]',
                google_address: '[client attribute=google_address]',
                country: '[client attribute=country]',
                residence_region: '[client attribute=residence_region]',
                residence_province: '[client attribute=residence_province]',
                residence_city: '[client attribute=residence_city]',
                residence_postal_code: '[client attribute=residence_postal_code]',
                address_road_type: '[client attribute=address_road_type]',
                address_street: '[client attribute=address_street]',
                address_street_nr: '[client attribute=address_street_nr]',
                address_portal: '[client attribute=address_portal]',
                address_floor: '[client attribute=address_floor]',
                address_door_nr: '[client attribute=address_door_nr]',
                po_box: '[client attribute=po_box]',
                main_head_address_same: '[client attribute=main_head_address_same]',
                main_activity_country: '[client attribute=main_activity_country]',
                main_activity_region: '[client attribute=main_activity_region]',
                main_activity_province: '[client attribute=main_activity_province]',
                main_activity_city: '[client attribute=main_activity_city]',
                main_activity_postal_code: '[client attribute=main_activity_postal_code]',
                main_activity_address_road_type: '[client attribute=main_activity_address_road_type]',
                main_activity_address_street: '[client attribute=main_activity_address_street]',
                main_activity_address_street_nr: '[client attribute=main_activity_address_street_nr]',
                main_activity_address_portal: '[client attribute=main_activity_address_portal]',
                main_activity_address_floor: '[client attribute=main_activity_address_floor]',
                main_activity_address_door_nr: '[client attribute=main_activity_address_door_nr]',
                main_activity_po_box: '[client attribute=main_activity_po_box]',
                id_type: '[client attribute=id_type]',
                id_issuer: '[client attribute=id_issuer]',
                id_number: '[client attribute=id_number]',
                id_expiration_date: '[client attribute=id_expiration_date]',
                country_permanent_residence: '[client attribute=country_permanent_residence]',
                id_permanent_residence: '[client attribute=id_permanent_residence]',
                permanent_residence_registration_date: '[client attribute=permanent_residence_registration_date]',
                country_temporary_residence: '[client attribute=country_temporary_residence]',
                id_temporary_residence: '[client attribute=id_temporary_residence]',
                employment: '[client attribute=employment]',
                tax_id_natural: '[client attribute=tax_id_natural]',
                tax_id_legal: '[client attribute=tax_id_legal]',
                pep: '[client attribute=pep]',
                political_exposure: '[client attribute=political_exposure]',
                ultimate_beneficial_owner: '[client attribute=ultimate_beneficial_owner]',
                primary_language: '[client attribute=primary_language]',
                secondary_language: '[client attribute=secondary_language]',
                non_profit_activity: '[client attribute=non_profit_activity]',
                legal_form: '[client attribute=legal_form]',
                registration_country: '[client attribute=registration_country]',
                registration_city: '[client attribute=registration_city]',
                statute_incorporation: '[client attribute=statute_incorporation]',
                act_incorporation: '[client attribute=act_incorporation]',
                unique_id_number: '[client attribute=unique_id_number]',
                nature_of_activities: '[client attribute=nature_of_activities]',
                factual_controller_name: '[client attribute=factual_controller_name]',
            }
        },
        {
            title: 'Dossiers',
            templates: ['dossier'],
            codes: {
                property_id: '[dossier attribute=property_id]',
                assigned_to: '[dossier attribute=assigned_to]',
                clients: '[dossier attribute=clients]',
                dossier_status: '[dossier attribute=dossier_status]',
                dossier_description: '[dossier attribute=dossier_description]',
                purpose: '[dossier attribute=purpose]',
                other_purpose: '[dossier attribute=other_purpose]',
                date_contract: '[dossier attribute=date_contract]',
                estimated_closing_date: '[dossier attribute=estimated_closing_date]',
                closing_date: '[dossier attribute=closing_date]',
                sales_price: '[dossier attribute=sales_price]',
                closing_costs: '[dossier attribute=closing_costs]',
                own_funds: '[dossier attribute=own_funds]',
                financed_amount: '[dossier attribute=financed_amount]',
                total_cost: '[dossier attribute=total_cost]',
                commission_included: '[dossier attribute=commission_included]',
                commission_value: '[dossier attribute=commission_value]',
                commission_payer: '[dossier attribute=commission_payer]',
            }
        },
        {
            title: 'user',
            templates: ['commercial_property', 'client', 'dossier'],
            codes: {
                firstname: '[user attribute=firstname]',
                lastname: '[user attribute=lastname]',
                username: '[user attribute=username]',
                status: '[user attribute=status]',
                role: '[user attribute=role]',
                reports_to: '[user attribute=reports_to]',
                agency: '[user attribute=agency]',
                email: '[user attribute=email]',
                phone: '[user attribute=phone]',
                office_phone: '[user attribute=office_phone]',
                dp: '[user attribute=dp]',
            }
        },
        {
            title: 'Task',
            templates: ['task'],
            codes: {
                subject: '[task attribute=subject]',
                priority: '[task attribute=priority]',
                repeate_type: '[task attribute=repeate_type]',
                start_date: '[task attribute=start_date]',
                start_time: '[task attribute=start_time]',
                status: '[task attribute=status]',
                end_date: '[task attribute=end_date]',
                end_time: '[task attribute=end_time]',
                from: '[task attribute=from]',
                assignee: '[task attribute=assignee]',
                related_to: '[task attribute=related_to]',
                description: '[task attribute=description]',
                contacts: '[task attribute=contacts]'
            }
        },
        {
            title: 'Invoice',
            templates: ['invoice'],
            codes: {
                invoice_number: '[invoice attribute=invoice_number]',
                billingAddress: '[invoice attribute=billingAddress]',
                subject: '[invoice attribute=subject]',
                invoiceDate: '[invoice attribute=invoice_date]',
                dueDate: '[invoice attribute=due_date]',
                entityName: '[invoice attribute=entityName]',
                entityEmail: '[invoice attribute=entityEmail]',
                entityLanguage: '[invoice attribute=entityLanguage]',
                invoiceStatus: '[invoice attribute=invoiceStatus]',
                totalInvoice: '[invoice attribute=total_invoice]',
                totalPaid: '[invoice attribute=total_paid]',
                outstandingBalance: '[invoice attribute=outstanding_balance]',
                outstandingPercentage: '[invoice attribute=outstanding_percentage]',
                type: '[invoice attribute=type]',
                Currency: '[invoice attribute=currency]',
                paymentMethod: '[invoice attribute= paymentMethod]',
            }
        },
        {
            title: 'agency',
            templates: ['commercial_property', 'client', 'dossier'],
            codes: {
                logo: '[agency attribute=logo]',
                phone: '[agency attribute=phone]',
                fax: '[agency attribute=fax]',
                email: '[agency attribute=email]',
                commercial_name: '[agency attribute=commercial_name]',
                address_street: '[agency attribute=complete_address_street]',
                address_street_number: '[agency attribute=complete_address_street_number]',
                address_postal_code: '[agency attribute=complete_address_postal_code]',
                address_city: '[agency attribute=complete_address_city]',
                address_province: '[agency attribute=complete_address_province]',
                address_country: '[agency attribute=complete_address_country]',
            }
        },
        {
            title: 'common',
            templates: ['all'],
            codes: {
                phone_icon: '[common attribute=phone_icon]',
                year: '[common attribute=year]',
                today_date: '[common attribute=today_date]'
            }
        },
        {
            title: 'invited_user',
            templates: ['signup_invitation'],
            codes: {
                firstname: '[invited_user attribute=firstname]',
                lastname: '[invited_user attribute=lastname]',
                email: '[invited_user attribute=email]',
                invitation_url: '[invited_user attribute=invitation_url]',
                pricing_group: '[invited_user attribute=pricing_group]',
                organisation: '[invited_user attribute=organisation]',
            }
        },
        {
            title: 'auth_otp',
            templates: ['auth_otp'],
            codes: {
                otp_code: '[auth_otp attribute=otp_code]',
                time_to_expire: '[auth_otp attribute=time_to_expire]'
            }
        }
    ];

}
